import React from 'react';
import { motion } from 'framer-motion';
import { FaStore, FaVideo, FaChartLine, FaCog, FaShoppingCart } from 'react-icons/fa';

// Animation variants
const tabContainerVariants = {
  initial: { opacity: 0, y: -10 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.4,
      staggerChildren: 0.1
    }
  }
};

const tabItemVariants = {
  initial: { opacity: 0, y: -10 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 15
    }
  },
  tap: { scale: 0.95 }
};

const TabNavigation = ({ activeTab, setActiveTab }) => {
  return (
    <motion.div
      variants={tabContainerVariants}
      initial="initial"
      animate="animate"
      style={{
        display: 'flex',
        marginBottom: '2rem',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '12px',
        padding: '0.5rem',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        border: '1px solid rgba(255,255,255,0.1)'
      }}
    >
      {/* Tab Indicator */}
      <motion.div
        animate={{
          x: activeTab === 'dashboard' ? '0%' : 
             activeTab === 'products' ? '25%' : 
             activeTab === 'events' ? '50%' : '75%'
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{
          position: 'absolute',
          width: '25%',
          height: '85%',
          background: 'linear-gradient(90deg, rgba(74,144,226,0.2), rgba(74,144,226,0.1))',
          borderRadius: '8px',
          top: '7.5%',
          left: 0,
          zIndex: 0,
          boxShadow: '0 2px 10px rgba(74,144,226,0.15)'
        }}
      />
      
      {/* Dashboard Tab */}
      <motion.div
        variants={tabItemVariants}
        whileHover={{ backgroundColor: 'rgba(74,144,226,0.1)' }}
        whileTap="tap"
        onClick={() => setActiveTab('dashboard')}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.8rem 0.5rem',
          color: activeTab === 'dashboard' ? '#4a90e2' : 'rgba(255,255,255,0.7)',
          fontWeight: activeTab === 'dashboard' ? 600 : 400,
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s ease',
          borderRadius: '8px'
        }}
      >
        <FaStore style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
        <span>Dashboard</span>
      </motion.div>
      
      {/* Products Tab */}
      <motion.div
        variants={tabItemVariants}
        whileHover={{ backgroundColor: 'rgba(74,144,226,0.1)' }}
        whileTap="tap"
        onClick={() => setActiveTab('products')}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.8rem 0.5rem',
          color: activeTab === 'products' ? '#4a90e2' : 'rgba(255,255,255,0.7)',
          fontWeight: activeTab === 'products' ? 600 : 400,
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s ease',
          borderRadius: '8px'
        }}
      >
        <FaShoppingCart style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
        <span>Products</span>
      </motion.div>
      
      {/* Events Tab */}
      <motion.div
        variants={tabItemVariants}
        whileHover={{ backgroundColor: 'rgba(74,144,226,0.1)' }}
        whileTap="tap"
        onClick={() => setActiveTab('events')}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.8rem 0.5rem',
          color: activeTab === 'events' ? '#4a90e2' : 'rgba(255,255,255,0.7)',
          fontWeight: activeTab === 'events' ? 600 : 400,
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s ease',
          borderRadius: '8px'
        }}
      >
        <FaVideo style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
        <span>Events</span>
      </motion.div>
      
      {/* Analytics Tab */}
      <motion.div
        variants={tabItemVariants}
        whileHover={{ backgroundColor: 'rgba(74,144,226,0.1)' }}
        whileTap="tap"
        onClick={() => setActiveTab('analytics')}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.8rem 0.5rem',
          color: activeTab === 'analytics' ? '#4a90e2' : 'rgba(255,255,255,0.7)',
          fontWeight: activeTab === 'analytics' ? 600 : 400,
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s ease',
          borderRadius: '8px'
        }}
      >
        <FaChartLine style={{ marginRight: '0.5rem', fontSize: '1.1rem' }} />
        <span>Analytics</span>
      </motion.div>
    </motion.div>
  );
};

export default TabNavigation;
